module.exports = __webpack_public_path__ + "static/media/stm-payment-bulb.ddfd282f.svg";